/**
 * Group exposed TCP/UDP ports into service roles for Corporate / Email infra UI.
 */

/** @type {ReadonlySet<number>} */
export const WEB_PORTS = new Set([80, 443, 8080, 8443]);

/** @type {ReadonlySet<number>} */
export const MAIL_PORTS = new Set([25, 110, 143, 465, 587, 993, 995]);

/** @type {ReadonlySet<number>} */
export const ADMIN_PORTS = new Set([22, 53, 111, 135, 139, 445, 3389, 5900]);

const ADMIN_LABELS = {
  22: 'SSH',
  53: 'DNS',
  111: 'RPC',
  135: 'RPC',
  139: 'SMB',
  445: 'SMB',
  3389: 'RDP',
  5900: 'VNC',
};

/**
 * @param {unknown} value
 * @returns {number[]}
 */
export function normalizePortList(value) {
  if (!Array.isArray(value)) return [];
  const out = [];
  const seen = new Set();
  for (const raw of value) {
    const n = Number(raw);
    if (!Number.isFinite(n) || n <= 0 || n > 65535) continue;
    const port = Math.trunc(n);
    if (seen.has(port)) continue;
    seen.add(port);
    out.push(port);
  }
  return out.sort((a, b) => a - b);
}

/**
 * @param {unknown} ports
 * @returns {{
 *   web: number[],
 *   mail: number[],
 *   admin: { port: number, label: string }[],
 *   other: number[],
 *   hasAdminAlert: boolean,
 * }}
 */
export function groupExposedPorts(ports) {
  const list = normalizePortList(ports);
  const web = [];
  const mail = [];
  const admin = [];
  const other = [];
  for (const port of list) {
    if (WEB_PORTS.has(port)) web.push(port);
    else if (MAIL_PORTS.has(port)) mail.push(port);
    else if (ADMIN_PORTS.has(port)) {
      admin.push({ port, label: ADMIN_LABELS[port] || 'Admin' });
    } else other.push(port);
  }
  return {
    web,
    mail,
    admin,
    other,
    hasAdminAlert: admin.some((a) => a.port === 22 || a.port === 3389 || a.port === 5900),
  };
}
